import styles from './style.module.scss';
import React, { useEffect, useState } from 'react';
import { launchToast } from '../../utils';
import { img_logo } from '../../assets';
import { AUTH_API } from '../../api-handle/modules/auth.api';
import { Link, useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import moment from 'moment';

/**
 * ConfirmResetPassword component:
 * Standar confirm reset password component for the application.
 */
export default function ConfirmResetPassword() {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState('');
  const [tokenValid, setTokenValid] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = window.location.search.split('?token=')[1];
    try {
      if (token) {
        let { timestamp } = jwt_decode(token);
        let exp__ =
          timestamp.slice(0, 4) +
          '-' +
          timestamp.slice(4, 6) +
          '-' +
          timestamp.slice(6, 11) +
          ':' +
          timestamp.slice(11, 13) +
          ':' +
          timestamp.slice(13);

        if (moment(exp__).diff(moment(), 'days') < 1) {
          setTokenValid(true);
          setToken(token);
        } else {
          setTokenValid(false);
          throw new Error('Token expired');
        }
      } else {
        throw new Error('No token found');
      }
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let res = await AUTH_API.confirmResetPassword(password, token);
      if (res.status) {
        launchToast.success('Password Reset Successfull!');
        navigate('/login');
      } else throw new Error(res.message);
    } catch (error) {
      launchToast.error(error.message);
    }
    setIsLoading(false);
  };

  return (
    <div className={`${styles.Login} h-100vh`}>
      <div
        className={
          'container h-100 d-flex justify-content-center ' +
          'align-items-center'
        }
      >
        <div
          className="card p-4 py-4 w-100 shadow rounded-15"
          style={{ maxWidth: '450px' }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={img_logo}
              alt="logo"
              className="img-fluid mb-5"
              width={200}
            />
          </div>
          {tokenValid ? (
            <form
              className={
                'w-100 d-flex flex-column justify-content-center' +
                ' align-items-start gap-2'
              }
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="fw-bold">New Password</div>
              <input
                type="password"
                className="form-control w-100"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className={
                  'pt-2 d-flex justify-content-center ' +
                  'align-items-center w-100'
                }
              >
                <button
                  type="submit"
                  className="btn btn-primary px-4 "
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="spinner-grow text-light small spinner-grow-sm"></div>
                  ) : (
                    <div className="fw-bold">Reset Password</div>
                  )}
                </button>
              </div>
            </form>
          ) : (
            <div className="text-center">
              <div className="fw-bold">Link Expired</div>
              <div className="text-muted">
                Please request a new password reset link
              </div>
              <div
                className={
                  'pt-2 d-flex justify-content-center ' +
                  'align-items-center w-100'
                }
              >
                <Link to="/forgot-password" className="btn btn-primary px-4 ">
                  <div className="fw-bold">Reset Password</div>
                </Link>
              </div>
            </div>
          )}
          <br />
          <Link to={'/login'}>
            <div className="link-primary">
              <small className="fw-bold">Back to Login?</small>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
